import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData, selectIsSubscription } from '../../../../../../selectors/buyPackageModal';
import { pluralDays } from '../../../../../../utils/string';
import { Detail } from '../Detail';
import { getTitle } from './utils';

export const ValidityPeriodContainer = () => {
  const data = useSelector(selectBuyPackageModalData);
  const isSubscription = useSelector(selectIsSubscription);

  const { activationDate, endDate, durationInDays } = data;

  const title = getTitle(isSubscription);

  return (
    <Detail title={title}>
      {activationDate} — {endDate}&nbsp;({pluralDays(durationInDays)})
    </Detail>
  );
};
